import { useRef } from 'react';
import useBlockJump from '../../../hook/block/useBlockCamera';
import { useBotStateContext } from '../../../contexts/BotContext';
import './ButtonCenterView.css';
import useShiftKey from '../../../hook/useShiftKey';

// Button to replace the view on the first scenario
function ButtonCenterView() {

    const { blockStart } = useBotStateContext();
    
    const { jumpToPosition } = useBlockJump();

    const { changeShiftKey, shiftKey } = useShiftKey();

    const onClick = () => {
        shiftKey ? changeShiftKey() : null;
        jumpToPosition(blockStart.x, blockStart.y)
    }

    return <div className="recenter" onClick={onClick}></div>
}

export default ButtonCenterView